import { turboproApi } from '@/api/turbopro';
import type { GerarRelatorioPayload, GerarRelatorioPDFResponse } from '../types';
import { getRelatoriosHeaders } from './shared';

export async function gerarRelatorioPdfApi(
  payload: GerarRelatorioPayload
): Promise<GerarRelatorioPDFResponse> {
  const resposta = await turboproApi<GerarRelatorioPDFResponse>('Relatorios/GerarRelatorioPDF', {
    method: 'POST',
    body: payload,
    headers: getRelatoriosHeaders(),
  });
  return resposta.data;
}
